<div id="mainContent" class="container" *ngIf="showClientConveyanceDetails">
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">
      Client Conveyance Summary
    </h5>
  </div>

  <div class="modal-body mt-2">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onYearSelected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4">Branch </label>
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs"
              id="branch"
              name="branch"
              [(ngModel)]="selectedBranch"
              (change)="onSelectBranch()"
            >
              <option value="">Select Branch</option>
              <option *ngFor="let branch of branchList" [value]="branch.id">
                {{ branch.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Client Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedClientStatus"
              (change)="onStatusSelect()"
            >
            <option value="">Select Status</option>
              <option value="1">Active</option>
              <option value="2">Closed</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4">Client </label>
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs"
              id="client"
              name="client"
              [(ngModel)]="selectClientName"
              (change)="onSelectClientName()"
            >
              <option value="">Select Client</option>
              <option *ngFor="let client of clientNameList" [value]="client.id">
                {{ client.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Bill Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectBillingDate"
            >
              <option value="">Select Billing Date</option>
              <option
                *ngFor="let billingdate of billingDateList"
                [ngValue]="billingdate"
              >
                {{ billingdate.generatedDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <button
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Details
            </button>
          </div>
          <div class="col-sm-4" *ngIf="showExportToExcelButton">
            <button
              (click)="exportToExcelClientCoveyance()"
              class="btn btn-sm btn-block btn-outline-theme"
            >
              <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
            </button>
          </div>

          <div class="col-sm-4" *ngIf="showExportToExcelButton">
            <button
              (click)="exportAsPDFClientConveyanceSummary()"
              class="btn btn-sm btn-block btn-outline-theme"
            >
              <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="showConveyanceTableDetails">

      <div class="row mt-4 justify-content-center text-center">
        <span class="bg-theme-title"
          >P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>

      <div class="row mt-3 justify-content-center text-center">
          <span class="bg-theme-title">Client Conveyance Summary</span>
      </div>

      <div class="row mt-2">
        <label class="col-form-label"
          ><b>Bill Date: </b
          >{{ selectBillingDate.generatedDate | date: "dd-MMM-yyyy" }}</label
        >
      </div>

      <div class="row">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Diary Closing Date</th>
              <th>Period</th>
              <th>Billed Amount</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="
                let client of clientConveyanceList;
                let clientIndex = index;
                let clientCount = count
              "
            >
              <ng-container
                *ngFor="
                  let closingDate of client.diaryClosingDates;
                  let closingDateIndex = index;
                  let closingDateCount = count
                "
              >
                <ng-container
                  *ngFor="
                    let period of closingDate.periods;
                    let periodIndex = index;
                    let periodCount = count
                  "
                >
                  <tr *ngIf="closingDateIndex == 0 && periodIndex == 0">
                    <td
                      [attr.rowspan]="getRowSpanForClient(client) + 1"
                      style="color: blue; cursor: pointer"
                      (click)="
                        getClientBilledConveyanceList(
                          client.clientId,
                          client.billingId
                        )
                      "
                    >
                      {{ client.clientName }}
                    </td>
                    <td [attr.rowspan]="periodCount">
                      {{
                        (closingDate.diaryClosigDate | date: "dd-MM-yyyy") ===
                        "11-11-1111"
                          ? "Not Closed"
                          : (closingDate.diaryClosigDate
                              | date: "dd-MM-yyyy") === "11-02-1950"
                          ? "Not Closed"
                          : (closingDate.diaryClosigDate | date: "dd-MM-yyyy")
                      }}
                    </td>
                    <td
                      (click)="
                        getClientMonthlyConveyanceList(
                          client.clientId,
                          closingDate.closingId,
                          period.month,
                          period.year
                        )
                      "
                      style="color: blue; cursor: pointer"
                    >
                      {{ changeMonthNumberToName(period.month) }} -
                      {{ period.year }}
                    </td>
                    <td>{{ period.amount }}</td>
                  </tr>
                  <tr *ngIf="closingDateIndex != 0 && periodIndex == 0">
                    <td [attr.rowspan]="periodCount">
                      {{
                        (closingDate.diaryClosigDate | date: "dd-MM-yyyy") ===
                        "11-11-1111"
                          ? "Not Closed"
                          : (closingDate.diaryClosigDate
                              | date: "dd-MM-yyyy") === "11-02-1950"
                          ? "Not Closed"
                          : (closingDate.diaryClosigDate | date: "dd-MM-yyyy")
                      }}
                    </td>
                    <td
                      (click)="
                        getClientMonthlyConveyanceList(
                          client.clientId,
                          closingDate.closingId,
                          period.month,
                          period.year
                        )
                      "
                      style="color: blue; cursor: pointer"
                    >
                      {{ changeMonthNumberToName(period.month) }} -
                      {{ period.year }}
                    </td>
                    <td>{{ period.amount }}</td>
                  </tr>
                  <tr *ngIf="periodIndex != 0">
                    <td
                      (click)="
                        getClientMonthlyConveyanceList(
                          client.clientId,
                          closingDate.closingId,
                          period.month,
                          period.year
                        )
                      "
                      style="color: blue; cursor: pointer"
                    >
                      {{ changeMonthNumberToName(period.month) }} -
                      {{ period.year }}
                    </td>
                    <td>{{ period.amount }}</td>
                  </tr>
                  <tr
                    *ngIf="
                      closingDateCount == closingDateIndex + 1 &&
                      periodCount == periodIndex + 1
                    "
                    style="background-color: #e1f4f7"
                  >
                    <td>Diary Total</td>
                    <td></td>
                    <td>
                      {{ calculateBillingAmount(client.diaryClosingDates) }}
                    </td>
                  </tr>

                  <tr
                    *ngIf="
                      closingDateCount == closingDateIndex + 1 &&
                      periodCount == periodIndex + 1
                    "
                    style="background-color: #e1f4f7"
                  >
                    <td>Travel Total</td>
                    <td></td>
                    <td>
                      {{ client.tsheetAllowance }}
                    </td>
                  </tr>

                  <tr
                    *ngIf="
                      clientCount == clientIndex + 1 &&
                      closingDateCount == closingDateIndex + 1 &&
                      periodCount == periodIndex + 1
                    "
                    style="background-color: #e1f4f7"
                  >
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td>{{ allBillingAmountTotal }}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Client Billed Conveyance Report-->
<div
  class="container"
  *ngIf="clientBilledConveyanceList != null && showBilledConveyanceDetails"
>
<div class="row justify-content-center text-center mt-4">
  <span class="bg-theme-title"
    >P G BHAGWAT LLP, Chartered Accountants
  </span>
</div>
<div class="row justify-content-center text-center ">
  <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
</div>
  <div class="row mt-2">
    <div class="col-md-5" (click)="goBack()">
      <i class="fa fa-arrow-circle-o-left fa-2x"></i>
    </div>
    <div class="col-md-5">
      <span class="bg-theme-title">Billed Conveyance Details</span>
    </div>
    <div class="col-md-2" *ngIf="showBilledExportToExcelButton">
      <button
        (click)="exportToExcelClientBilledConveyance()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>
  </div>
  <div class="animate__animated animate__fadeInLeft mt-3">
    <div class="row">
      <div class="col-sm-6">
        <label class="col-form-label"
          ><b>Client Name: {{ clientBilledConveyanceList.client }}</b></label
        >
      </div>
      <div class="col-sm-6" style="display: flex; justify-content: flex-end">
        <label class="col-form-label"
          ><b
            >Bill Date:
            {{ clientBilledConveyanceList.billDate | date: "dd-MMM-yyyy" }}</b
          ></label
        >
      </div>
    </div>

    <div class="row">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Diary Date</th>
            <th>Employee / Article Name</th>
            <th>Assignment</th>
            <th>Task</th>
            <th>Two Wheeler</th>
            <th>Four Wheeler</th>
            <th>Bus/Auto/Other</th>
            <th>Billed Conveyance</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let diaryDate of clientBilledConveyanceList.diaryDates;
              let diaryDateIndex = index;
              let diaryDateCount = count
            "
          >
            <ng-container
              *ngFor="
                let diaryDetail of diaryDate.diaryDetails;
                let diaryDetailIndex = index;
                let diaryDetailCount = count
              "
            >
              <tr *ngIf="diaryDetailIndex == 0">
                <td [attr.rowspan]="getRowSpanForDiaryDate(diaryDate)">
                  {{ diaryDate.diaryDate | date: "dd-MMM-yyyy" }}
                </td>
                <td>{{ diaryDetail.firstName }}{{ diaryDetail.lastName }}</td>
                <td>{{ diaryDetail.assignment }}</td>
                <td>{{ diaryDetail.task }}</td>
                <td>{{ diaryDetail.twoWheeler }}</td>
                <td>{{ diaryDetail.fourWheeler }}</td>
                <td>{{ diaryDetail.busAuto }}</td>
                <td>{{ diaryDetail.billedConveyance }}</td>
              </tr>
              <tr *ngIf="diaryDetailIndex != 0">
                <td>{{ diaryDetail.firstName }}{{ diaryDetail.lastName }}</td>
                <td>{{ diaryDetail.assignment }}</td>
                <td>{{ diaryDetail.task }}</td>
                <td>{{ diaryDetail.twoWheeler }}</td>
                <td>{{ diaryDetail.fourWheeler }}</td>
                <td>{{ diaryDetail.busAuto }}</td>
                <td>{{ diaryDetail.billedConveyance }}</td>
              </tr>
              <tr
                *ngIf="
                  diaryDateCount == diaryDateIndex + 1 &&
                  diaryDetailCount == diaryDetailIndex + 1
                "
                style="background-color: #e1f4f7"
              >
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ totalTwoWheelerCount }}</td>
                <td>{{ totalFourWheelerCount }}</td>
                <td>{{ totalBusAutoCount }}</td>
                <td>{{ totalBilledConveyanceCount }}</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!--Client Monthly Conveyance Report-->
<div
  class="container"
  *ngIf="clientMonthlyConveyanceList != null && showMonthlyConveyanceDetails"
>
<div class="row justify-content-center text-center mt-4">
  <span class="bg-theme-title"
    >P G BHAGWAT LLP, Chartered Accountants
  </span>
</div>
<div class="row justify-content-center text-center ">
  <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
</div>
  <div class="row mt-2">
    <div class="col-sm-5" (click)="goBack()">
      <i class="fa fa-arrow-circle-o-left fa-2x"></i>
    </div>
    <div class="col-sm-5">
      <span class="bg-theme-title">Monthly Conveyance Details</span>
    </div>
    <div class="col-sm-2" *ngIf="showMonthlyExportToExcelButton">
      <button
        (click)="exportToExcelClientMonthlyConveyanceList()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-5"></div>
    <div class="col-sm-7">
      <span class="bg-theme-title"
        >Closing Date :
        {{
          clientMonthlyConveyanceList.closingDate | date: "dd-MMM-yyyy"
        }}</span
      >
    </div>
  </div>
  <div class="animate__animated animate__fadeInLeft mt-3">
    <div class="row">
      <div class="col-sm-6">
        <label class="col-form-label"
          ><b>Client Name: {{ clientMonthlyConveyanceList.client }}</b></label
        >
      </div>
      <div class="col-sm-6" style="display: flex; justify-content: flex-end">
        <label class="col-form-label"
          ><b
            >Period:
            {{
              changeMonthToNumberMonthlyConveyance(
                clientMonthlyConveyanceList.pMonth
              )
            }}-{{ clientMonthlyConveyanceList.pYear }}</b
          ></label
        >
      </div>
    </div>

    <div class="row">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Diary Date</th>
            <th>Employee / Article Name</th>
            <th>Assignment</th>
            <th>Task</th>
            <th>Mode</th>
            <th>Distance</th>
            <th>Rate</th>
            <th>Total Conveyance</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let diaryDate of clientMonthlyConveyanceList.diaryDates;
              let diaryDateIndex = index;
              let diaryDateCount = count
            "
          >
            <ng-container
              *ngFor="
                let diaryDetail of diaryDate.diaryDetails;
                let diaryDetailIndex = index;
                let diaryDetailCount = count
              "
            >
              <tr *ngIf="diaryDetailIndex == 0">
                <td [attr.rowspan]="getRowSpanForDiaryDate(diaryDate)">
                  {{ diaryDate.diaryDate | date: "dd-MM-yyyy" }}
                </td>
                <td>{{ diaryDetail.firstName }}{{ diaryDetail.lastName }}</td>
                <td>{{ diaryDetail.assignment }}</td>
                <td>{{ diaryDetail.task }}</td>
                <td>{{ diaryDetail.mode }}</td>
                <td>{{ diaryDetail.distance }}</td>
                <td>{{ diaryDetail.rate }}</td>
                <td>{{ diaryDetail.totalConveyance }}</td>
              </tr>
              <tr *ngIf="diaryDetailIndex != 0">
                <td>{{ diaryDetail.firstName }}{{ diaryDetail.lastName }}</td>
                <td>{{ diaryDetail.assignment }}</td>
                <td>{{ diaryDetail.task }}</td>
                <td>{{ diaryDetail.mode }}</td>
                <td>{{ diaryDetail.distance }}</td>
                <td>{{ diaryDetail.rate }}</td>
                <td>{{ diaryDetail.totalConveyance }}</td>
              </tr>
              <tr
                *ngIf="
                  diaryDateCount == diaryDateIndex + 1 &&
                  diaryDetailCount == diaryDetailIndex + 1
                "
                style="background-color: #e1f4f7"
              >
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ totalMonthlyConveyanceCount }}</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
